import API from "@utils/plugins/API";

const HullMaterialService = {
  all: (params) => {
    return API.get("hull-materials", { params: params });
  },
  create: (name, name_eng, hull_materials_eu_id, description) => {
    return API.post("hull-materials", {
      name,
      name_eng,
      hull_materials_eu_id,
      description,
    });
  },
  update: (id, name, name_eng, hull_materials_eu_id, description) => {
    return API.put(`hull-materials/${id}`, {
      name,
      name_eng,
      hull_materials_eu_id,
      description,
    });
  },
  find: (id) => {
    return API.get(`hull-materials/${id}`);
  },
  destroy: (id) => {
    return API.delete(`hull-materials/${id}`);
  },
};

export default HullMaterialService;
